{
  "version": 1,
  "asset_id": "4d50e7ea-e39f-4f6d-bf99-60f175b54c71",
  "project_id": "ce9c7bc3-4703-4722-9a23-513bcb210c19",
  "url": "/__l5e/assets-v1/4d50e7ea-e39f-4f6d-bf99-60f175b54c71/popclub.webp",
  "r2_key": "a/v1/ce9c7bc3-4703-4722-9a23-513bcb210c19/4d50e7ea-e39f-4f6d-bf99-60f175b54c71/popclub.webp",
  "original_filename": "popclub.webp",
  "size": 4896,
  "content_type": "image/webp",
  "created_at": "2026-07-17T21:18:09Z"
}
